import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as superAdminActions from '../../ducks/super-admin'
import * as accountActions from '../../ducks/account'
import OrganisationList from '../OrganisationList'

class OrganisationListContainer extends React.Component {
  componentDidMount() {
    this.props.superAdminActions.fetchOrganisations()
  }

  handleSetCurrentOrganisation = organisation => {
    this.props.accountActions.setCurrentOrganisation({
      organisation,
      roles: ['admin', 'member']
    })
  }

  render() {
    return (
      <OrganisationList
        organisations={this.props.organisations}
        currentOrganisationId={this.props.currentOrganisationId}
        onSetCurrentOrganisation={this.handleSetCurrentOrganisation}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    organisations: state.superAdmin.get('organisations')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    superAdminActions: bindActionCreators(superAdminActions, dispatch),
    accountActions: bindActionCreators(accountActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationListContainer)



// WEBPACK FOOTER //
// ./src/components/smart/OrganisationListContainer.js